import Vue from 'vue'
import Vuex from 'vuex'
//引入模块
import { getItem, setItem } from '@/util/storage'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        // header 的 menu
        activePath: '/index',
        //使用模块中的方法
        user: getItem('user'),

        // 用户登录状态
        // user:JSON.parse(window.localStorage.getItem('user'))
        product: getItem('product'),
        company: getItem('company'),
        link: getItem('link'),
        language: getItem('language'),
    },
    mutations: {
        changActivePath(state, activePath) {
            state.activePath = activePath
        },
        // 修改
        setuser(state, data) {
            state.user = data
            setItem('user', state.user)
            // window.localStorage.setItem('user',JSON.stringify(state.user))
        },
        setproduct(state, data) {
            state.product = data
            setItem('product', state.product)
        },
        setcompany(state, data) {
            state.company = data
            setItem('company', state.company)
        },
        setlink(state, data) {
            state.link = data
            setItem('link', state.link)
        },
        setlanguage(state, data) {
            state.language = data
            setItem('language', state.language)
        },
    },
    actions: {
        //在actions中，不能直接修改state里面的数据；
        //必须通过context.commit()触发某个mutation才行
        //触发action 如下： //this.$store.dispatch('changActivePath','值');
        changActivePathAsync(context, activePath) {
            context.commit('changActivePath', activePath)
       },
    },
    modules: {
    }
})

